import Head from 'next/head';

interface HeaderProps {
  title: string;
  description: string;
}

export default function Header({ title, description }: HeaderProps) {
  const pageTitle = title;
  const pageDescription = description;
  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content="https://nevillegoddard.vercel.app" />
      <meta
        property="og:image"
        content="https://upload.wikimedia.org/wikipedia/commons/a/a1/Neville_Goddard.jpg"
      />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_GB" />
      <link rel="icon" href="/favicon.ico?v=1" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@rich_shipping" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta
        name="twitter:image"
        content="https://nevillegoddard.vercel.app/images/neville-goddard.jpg"
      />
    </Head>
  );
}
